import React from 'react';

import { DetailRowError } from '../detail-row/DetailRowError';

export const TaxImpactGainsAllowanceError: React.FC = () => {
  return <DetailRowError data-testid="gains-allowance">Remaining gains allowance</DetailRowError>;
};
